'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _Col = require('react-bootstrap/lib/Col');

var _Col2 = _interopRequireDefault(_Col);

var _Grid = require('react-bootstrap/lib/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _Table = require('react-bootstrap/lib/Table');

var _Table2 = _interopRequireDefault(_Table);

var _utils = require('../../utils');

var _TermsTableRow = require('./TermsTableRow');

var _TermsTableRow2 = _interopRequireDefault(_TermsTableRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var formatDuration = _utils.FormattingUtils.formatDuration;

var TermsTable = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(TermsTable, _Component);

  function TermsTable() {
    _classCallCheck(this, TermsTable);

    return _possibleConstructorReturn(this, (TermsTable.__proto__ || Object.getPrototypeOf(TermsTable)).apply(this, arguments));
  }

  _createClass(TermsTable, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          lien = _props.lien,
          allLocked = _props.allLocked,
          presets = _props.presets,
          terms = lien.getTermsPercent(),
          minimumText = lien.minimum_duration && formatDuration(lien.minimum_duration) + ' Minimum',
          lockedInput = (0, _get3.default)(lien.getPreset(presets), 'is_locked', false);


      return _react2.default.createElement(
        _Grid2.default,
        { className: 'table-terms', fluid: true },
        _react2.default.createElement(
          _Row2.default,
          null,
          lien.minimum_duration ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _Col2.default,
              { xs: 6 },
              _react2.default.createElement(
                'h3',
                null,
                'Contract Terms'
              )
            ),
            _react2.default.createElement(
              _Col2.default,
              { xs: 6 },
              _react2.default.createElement(
                'h3',
                { className: 'pull-right' },
                minimumText
              )
            )
          ) : _react2.default.createElement(
            _Col2.default,
            { xs: 12 },
            _react2.default.createElement(
              'h3',
              null,
              'Contract Terms'
            )
          )
        ),
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            _Col2.default,
            { xs: 12 },
            _react2.default.createElement(
              _Table2.default,
              { className: 'contract-terms fix-layout', condensed: true },
              _react2.default.createElement(
                'thead',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'th',
                    { className: 'col-sm-3' },
                    'Duration'
                  ),
                  _react2.default.createElement(
                    'th',
                    { className: 'col-sm-6 col-interest-rate' },
                    'Rate Of Return'
                  ),
                  _react2.default.createElement(
                    'th',
                    { className: 'col-sm-3 text-right' },
                    'Bucket Length'
                  )
                )
              ),
              _react2.default.createElement(
                'tbody',
                null,
                terms.map(function (term, idx) {
                  return _react2.default.createElement(_TermsTableRow2.default, {
                    id: idx,
                    key: idx,
                    length: terms.length,
                    locked: allLocked || lockedInput,
                    onChange: lien.setTermPercent,
                    term: term
                  });
                })
              )
            )
          )
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return TermsTable;
}(_react.Component), _class2.defaultProps = {
  allLocked: false
}, _class2.propTypes = {
  allLocked: _propTypes2.default.bool,
  lien: _propTypes2.default.object.isRequired,
  presets: _propTypes2.default.array
}, _temp)) || _class;

var _default = TermsTable;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(formatDuration, 'formatDuration', '/app/src/components/page-case/TermsTable.js');
  reactHotLoader.register(TermsTable, 'TermsTable', '/app/src/components/page-case/TermsTable.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/TermsTable.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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